import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

import SaveTheSearchButton from "components/save-the-search-button";
import { numberFormatter } from "helpers/number-formatter";

import styles from "./styles.module.css";

const SelectedFilterArea = dynamic(() => import("components/listing-search/selected-filter-area"), { ssr: false });

const TopSide = ({ listingData, totalListing, searchCriteria, searchName }) => (
  <div className={styles.wrapper}>
    <div className={styles.topWrap}>
      <h1 className={styles.title}>
        {searchName || listingData.name}
        <span className={styles.counter}>
          {!totalListing || totalListing === 0
            ? `araması için uygun ilan bulunamadı`
            : `(${numberFormatter(totalListing)} İlan)`}
        </span>
      </h1>
      <SaveTheSearchButton name={listingData?.name} urlPath={listingData?.url?.path} />
    </div>
    <div className={styles.filterWrap}>
      <SelectedFilterArea criteria={searchCriteria} screenType="map" />
    </div>
  </div>
);

TopSide.propTypes = {
  listingData: PropTypes.object,
  title: PropTypes.string,
  totalListing: PropTypes.number,
  searchCriteria: PropTypes.object,
  pageResponse: PropTypes.object,
  searchName: PropTypes.string,
};

export default TopSide;
